import React from 'react';

const PdfRightIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11.25" stroke="black" strokeWidth="1.5" />
    <path fillRule="evenodd" clipRule="evenodd" d="M10.3779 8.1977C10.6708 7.9048 11.1456 7.9048 11.4385 8.1977L14.7113 11.4704C15.0042 11.7633 15.0042 12.2382 14.7113 12.5311L11.4385 15.8038C11.1456 16.0967 10.6708 16.0967 10.3779 15.8038C10.085 15.5109 10.085 15.036 10.3779 14.7432L13.1203 12.0008L10.3779 9.25836C10.085 8.96546 10.085 8.49059 10.3779 8.1977Z" fill="black" />
  </svg>
);

export default PdfRightIcon;
